import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Process, Partners, Banner } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Banner />
        <Process />
        <Testimonials />
        <Team />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;